const FaNext = (props: { className?: string }) => {
  return (
    <svg className={props.className ?? ""} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Vector" d="M0 9L6.375 4.5L0 0V9ZM7.5 0V9H9V0H7.5Z" fill="currentColor" />
    </svg>

  );
}

export default FaNext;